module.exports = __webpack_public_path__ + "media/images/front/premium_lp/point03/th_02-145249fbb020d94b271884ccf5be1028.jpg";